import { render, staticRenderFns } from "./UserSelectInputWidget.vue?vue&type=template&id=2810aaf8&scoped=true"
import script from "./UserSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./UserSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2810aaf8",
  null
  
)

export default component.exports